export const isSelfServicePortalEnabled = (): boolean => (
  !!process.env.GATSBY_SSP_ENABLED && process.env.GATSBY_SSP_ENABLED.toLowerCase() === "true"
);

export const showUserNavigation = (isLoggedIn: boolean): boolean => (
  (!!process.env.GATSBY_SSP_SHOW_USER_NAVIGATION && process.env.GATSBY_SSP_SHOW_USER_NAVIGATION.toLowerCase() === "true")
  || isLoggedIn
);
